import { useIsOptimizedAudioBarsEnabled } from '@/features/flags';
import type { ComponentProps } from 'react';
import { ChronicleBars as LegacyChronicleBars } from './legacy/ChronicleBars';
import { ChronicleBars as OptimizedChronicleBars } from './optimized/ChronicleBars';

/**
 * SCR-6633 rollout switch: ON renders the compositor-backed optimized bars,
 * OFF the pre-SCR-6633 implementation (byte-identical under `legacy/`).
 */
export const ChronicleBars = (props: ComponentProps<typeof OptimizedChronicleBars>) =>
  useIsOptimizedAudioBarsEnabled() ? (
    <OptimizedChronicleBars {...props} />
  ) : (
    <LegacyChronicleBars {...props} />
  );
